import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The webcomics I love",
  "description": "",
  "published": "2009-12-13T00:00:00.000Z",
  "redirect_from": ["/blog/the-webcomics-i-love/swizec/960"],
  "categories": "Arts, Comics, intrigues, life, RSS, Uncategorized, Webcomic",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Webcomics have been an internet constant for a while now and while I've become a fan almost in their infancy back when Elftor and PA were king (I never read PA) ... oh must've been something like `}{`*`}{`gulp`}{`*`}{` eight years ago ... fuck I'm old.`}</p>
    <p>{`Anyhow, my second big love was CAD, which I've been reading to this day. Sometime during the whole affair I was quite popular on their forum, then a certain revolt happened, which I magically survived and then I got banned a few months later ... oh well. But I loved that forum, learned a lot about painting there.`}</p>
    <p>{`It would seem that there are even more comics that I used to read, but don't read anymore, than there are comics I `}<em parentName="p">{`do`}</em>{` read. There are such marvels as Pewfell, the Dreamwalker Chronicles and Lackadaisy - in all the bookmarks folder for webcomics holds `}<strong parentName="p">{`58`}</strong>{` different links. Out of those I only read twelve today, with a few new ones still in the buffer for me to go through the archives. So in no particular order:`}</p>
    <h3 {...{
      "id": "ctrl-alt-del"
    }}>{`Ctrl-Alt-Del`}</h3>
    <p><a parentName="p" {...{
        "href": "http://www.cad-comic.com/"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/12/Screen-shot-2009-12-14-at-1.34.50-AM.png",
          "alt": "Screen shot 2009-12-14 at 1.34.50 AM",
          "title": "Ctrl Alt Del"
        }}></img></a></p>
    <h3 {...{
      "id": "applegeeks"
    }}>{`AppleGeeks`}</h3>
    <p><a parentName="p" {...{
        "href": "http://www.applegeeks.com/"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/12/Screen-shot-2009-12-14-at-1.35.20-AM.png",
          "alt": "Screen shot 2009-12-14 at 1.35.20 AM",
          "title": "Applegeeks"
        }}></img></a></p>
    <h3 {...{
      "id": "bardsworth"
    }}>{`Bardsworth`}</h3>
    <p><a parentName="p" {...{
        "href": "http://www.bardsworth.com/"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/12/Screen-shot-2009-12-14-at-1.35.44-AM.png",
          "alt": "Screen shot 2009-12-14 at 1.35.44 AM",
          "title": "Bardsworth"
        }}></img></a></p>
    <h3 {...{
      "id": "bunny"
    }}>{`Bunny`}</h3>
    <p><a parentName="p" {...{
        "href": "http://www.frozenreality.co.uk/comic/bunny/"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/12/Screen-shot-2009-12-14-at-1.35.09-AM.png",
          "alt": "Screen shot 2009-12-14 at 1.35.09 AM",
          "title": "Bunny"
        }}></img></a></p>
    <h3 {...{
      "id": "commissioned"
    }}>{`Commissioned`}</h3>
    <p><a parentName="p" {...{
        "href": "http://www.commissionedcomic.com/"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/12/Screen-shot-2009-12-14-at-1.35.00-AM.png",
          "alt": "Screen shot 2009-12-14 at 1.35.00 AM",
          "title": "Commissioned"
        }}></img></a></p>
    <h3 {...{
      "id": "girl-genius"
    }}>{`Girl Genius`}</h3>
    <p><a parentName="p" {...{
        "href": "http://www.girlgeniusonline.com/"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/12/Screen-shot-2009-12-14-at-1.42.14-AM.png",
          "alt": "Screen shot 2009-12-14 at 1.42.14 AM",
          "title": "Girl Genius"
        }}></img></a></p>
    <h3 {...{
      "id": "not-invented-here"
    }}>{`Not Invented Here`}</h3>
    <p><a parentName="p" {...{
        "href": "http://notinventedhe.re/"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/12/Screen-shot-2009-12-14-at-1.38.56-AM.png",
          "alt": "Screen shot 2009-12-14 at 1.38.56 AM",
          "title": "Not Invented Here"
        }}></img></a></p>
    <h3 {...{
      "id": "phd-comics"
    }}>{`PHD Comics`}</h3>
    <p><a parentName="p" {...{
        "href": "http://www.phdcomics.com/comics.php"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/12/Screen-shot-2009-12-14-at-1.35.31-AM.png",
          "alt": "Screen shot 2009-12-14 at 1.35.31 AM",
          "title": "PHD Comics"
        }}></img></a></p>
    <h3 {...{
      "id": "sheldon-comic"
    }}>{`Sheldon Comic`}</h3>
    <p><a parentName="p" {...{
        "href": "http://www.sheldoncomics.com/"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/12/Screen-shot-2009-12-14-at-1.35.37-AM.png",
          "alt": "Screen shot 2009-12-14 at 1.35.37 AM",
          "title": "Sheldon Comic"
        }}></img></a></p>
    <h3 {...{
      "id": "wulffmorgenthaler"
    }}>{`Wulffmorgenthaler`}</h3>
    <p><a parentName="p" {...{
        "href": "http://www.wulffmorgenthaler.com/default.aspx"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/12/Screen-shot-2009-12-14-at-1.35.50-AM.png",
          "alt": "Screen shot 2009-12-14 at 1.35.50 AM",
          "title": "Wulffmorgenthaler"
        }}></img></a></p>
    <h3 {...{
      "id": "johnny-wander"
    }}>{`Johnny Wander`}</h3>
    <p><a parentName="p" {...{
        "href": "http://www.johnnywander.com/"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/12/Screen-shot-2009-12-14-at-1.44.28-AM.png",
          "alt": "Screen shot 2009-12-14 at 1.44.28 AM",
          "title": "Johnny Wander"
        }}></img></a></p>
    <h3 {...{
      "id": "lackadaisy"
    }}>{`Lackadaisy`}</h3>
    <p><a parentName="p" {...{
        "href": "http://lackadaisycats.com/index.php"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/12/Screen-shot-2009-12-14-at-1.45.30-AM.png",
          "alt": "Screen shot 2009-12-14 at 1.45.30 AM",
          "title": "Lackadaisy"
        }}></img></a></p>
    <p>{`Two honourable mentions also go to `}<a parentName="p" {...{
        "href": "http://www.boltcity.com/"
      }}>{`Copper`}</a>{`, which should really start updating again, and `}<a parentName="p" {...{
        "href": "http://uglyhill.com/"
      }}>{`Ugly Hill`}</a>{`, which ended, but @paulsouthworth awesomely went on to do Not Invented Here.`}</p>
    <p>{`Sadly, most of the comics I stopped reading lost my attention due to my simply forgetting to click the bookmark for a while. Henceforth this is remedied because I have resolved to continue reading only through RSS. Life is too hectic even `}<strong parentName="p">{`if `}</strong>{`the only really proper way to enjoy a webcomic is by going to the home page.`}</p>
    <p>{`PS: of course there is also XKCD, but I refuse to even bookmark that one. There's a special charm in entering the URL by hand every Monday, Wednesday and Friday.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/29634916-1c04-4f1d-a800-88d226ebefed/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=29634916-1c04-4f1d-a800-88d226ebefed",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      